import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const fetchCategories = createAsyncThunk("category/all-categories", async () => {
  const response = await fetch("https://joyfulserver.ddns.net:443/api/Category/all-categories");
  const result = await response.json(); // API-dən gələn ümumi nəticəni alırıq
  return result.data; // Yalnız `data` hissəsini qaytarırıq
});

export const addCategory = createAsyncThunk("category/addCategory", async (newCategory) => {
  const response = await fetch("https://joyfulserver.ddns.net:443/api/Category/add-category", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(newCategory),
  });
  return await response.json();
});


const categoriesSlice = createSlice({
    name: "categories",
    initialState: {
      categories: [],
      status: "idle",
      error: null,
    },
    reducers: {},
  
    extraReducers: (builder) => {
      builder
        .addCase(fetchCategories.pending, (state) => {
          state.status = "loading";
        })
        .addCase(fetchCategories.fulfilled, (state, action) => {
          state.status = "succeeded";
          state.categories = action.payload;
        })
        .addCase(fetchCategories.rejected, (state, action) => {
          state.status = "failed";
          state.error = action.error.message;
        })
        .addCase(addCategory.fulfilled, (state, action) => {
          state.categories.push(action.payload);
        })
    },
  });
  
  export default categoriesSlice.reducer;
